import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const phase_completed = ({ event: { kind, data: { phase_type } } }) =>
  <div className={kind}>
    <span style={{ textTransform: 'capitalize' }}>{phase_type}</span> Phase was Completed
  </div>;

phase_completed.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      phase_type: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_completed.jsx